export { default } from './TicketDetail.data';
